import { Router } from "./routes/routes";
import GlobalStyles from "./styles/GlobalStyles";

function App() {
  return (
    <>
      <Router />
      <GlobalStyles />
    </>
  );
}

export default App;
